"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Talenzap APIs
 * API documentation for the backend services of Talenzap
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminAppConfigApi = exports.AdminAppConfigApiFactory = exports.AdminAppConfigApiFp = exports.AdminAppConfigApiAxiosParamCreator = void 0;
var axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * AdminAppConfigApi - axios parameter creator
 * @export
 */
var AdminAppConfigApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create or update app configuration
         * @param {CreateOrUpdateAppConfigDto} createOrUpdateAppConfigDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAppConfigControllerCreateOrUpdateAppConfigV1: function (createOrUpdateAppConfigDto_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createOrUpdateAppConfigDto_1], args_1, true), void 0, function (createOrUpdateAppConfigDto, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createOrUpdateAppConfigDto' is not null or undefined
                            (0, common_1.assertParamExists)('adminAppConfigControllerCreateOrUpdateAppConfigV1', 'createOrUpdateAppConfigDto', createOrUpdateAppConfigDto);
                            localVarPath = "/v1/admin/app-config";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createOrUpdateAppConfigDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all active app configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAppConfigControllerGetAllAppConfigsV1: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/v1/admin/app-config";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AdminAppConfigApiAxiosParamCreator = AdminAppConfigApiAxiosParamCreator;
/**
 * AdminAppConfigApi - functional programming interface
 * @export
 */
var AdminAppConfigApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AdminAppConfigApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create or update app configuration
         * @param {CreateOrUpdateAppConfigDto} createOrUpdateAppConfigDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAppConfigControllerCreateOrUpdateAppConfigV1: function (createOrUpdateAppConfigDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminAppConfigControllerCreateOrUpdateAppConfigV1(createOrUpdateAppConfigDto, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminAppConfigApi.adminAppConfigControllerCreateOrUpdateAppConfigV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all active app configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAppConfigControllerGetAllAppConfigsV1: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminAppConfigControllerGetAllAppConfigsV1(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminAppConfigApi.adminAppConfigControllerGetAllAppConfigsV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.AdminAppConfigApiFp = AdminAppConfigApiFp;
/**
 * AdminAppConfigApi - factory interface
 * @export
 */
var AdminAppConfigApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AdminAppConfigApiFp)(configuration);
    return {
        /**
         *
         * @summary Create or update app configuration
         * @param {CreateOrUpdateAppConfigDto} createOrUpdateAppConfigDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAppConfigControllerCreateOrUpdateAppConfigV1: function (createOrUpdateAppConfigDto, options) {
            return localVarFp.adminAppConfigControllerCreateOrUpdateAppConfigV1(createOrUpdateAppConfigDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get all active app configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAppConfigControllerGetAllAppConfigsV1: function (options) {
            return localVarFp.adminAppConfigControllerGetAllAppConfigsV1(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AdminAppConfigApiFactory = AdminAppConfigApiFactory;
/**
 * AdminAppConfigApi - object-oriented interface
 * @export
 * @class AdminAppConfigApi
 * @extends {BaseAPI}
 */
var AdminAppConfigApi = /** @class */ (function (_super) {
    __extends(AdminAppConfigApi, _super);
    function AdminAppConfigApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create or update app configuration
     * @param {CreateOrUpdateAppConfigDto} createOrUpdateAppConfigDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAppConfigApi
     */
    AdminAppConfigApi.prototype.adminAppConfigControllerCreateOrUpdateAppConfigV1 = function (createOrUpdateAppConfigDto, options) {
        var _this = this;
        return (0, exports.AdminAppConfigApiFp)(this.configuration).adminAppConfigControllerCreateOrUpdateAppConfigV1(createOrUpdateAppConfigDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get all active app configurations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAppConfigApi
     */
    AdminAppConfigApi.prototype.adminAppConfigControllerGetAllAppConfigsV1 = function (options) {
        var _this = this;
        return (0, exports.AdminAppConfigApiFp)(this.configuration).adminAppConfigControllerGetAllAppConfigsV1(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AdminAppConfigApi;
}(base_1.BaseAPI));
exports.AdminAppConfigApi = AdminAppConfigApi;
